export default __webpack_public_path__ + "static/media/06.8b7ee187.jpg";